var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import styles from './DropdownLayout.scss';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import WixComponent from '../BaseComponents/WixComponent';
import isEqual from 'deep-eql';
import trim from 'lodash/trim';

var modulu = function modulu(n, m) {
  var remain = n % m;
  return remain >= 0 ? remain : remain + m;
};

var NOT_HOVERED_INDEX = -1;

var DropdownLayout = function (_WixComponent) {
  _inherits(DropdownLayout, _WixComponent);

  function DropdownLayout(props) {
    _classCallCheck(this, DropdownLayout);

    var _this = _possibleConstructorReturn(this, (DropdownLayout.__proto__ || Object.getPrototypeOf(DropdownLayout)).call(this, props));

    _this.state = {
      hovered: NOT_HOVERED_INDEX,
      selectedId: props.selectedId
    };

    _this._onSelect = _this._onSelect.bind(_this);
    _this._onMouseLeave = _this._onMouseLeave.bind(_this);
    _this._onMouseEnter = _this._onMouseEnter.bind(_this);
    _this._onKeyDown = _this._onKeyDown.bind(_this);
    _this._onClose = _this._onClose.bind(_this);
    _this.onClickOutside = _this.onClickOutside.bind(_this);
    return _this;
  }

  _createClass(DropdownLayout, [{
    key: 'isLegalOption',
    value: function isLegalOption(option) {
      return (typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && typeof option.id !== 'undefined' && trim(option.id).length > 0 && typeof option.value !== 'undefined' && (React.isValidElement(option.value) || typeof option.value === 'string' && trim(option.value).length > 0);
    }
  }, {
    key: 'onClickOutside',
    value: function onClickOutside(event) {
      var _props = this.props,
          visible = _props.visible,
          onClickOutside = _props.onClickOutside;

      if (visible && onClickOutside) {
        onClickOutside(event);
      }
    }
  }, {
    key: '_onSelect',
    value: function _onSelect(index) {
      var _props2 = this.props,
          options = _props2.options,
          onSelect = _props2.onSelect,
          selectedId = _props2.selectedId;

      this.setState({ selectedId: options[index] ? options[index].id : undefined });
      options[index] && onSelect && onSelect(options[index], options[index].id === selectedId);
      return !!onSelect && options[index];
    }
  }, {
    key: '_onMouseEnter',
    value: function _onMouseEnter(index) {
      if (this.isSelectableOption(this.props.options[index])) {
        this.setState({ hovered: index });
      }
    }
  }, {
    key: '_onMouseLeave',
    value: function _onMouseLeave() {
      this.setState({
        hovered: NOT_HOVERED_INDEX
      });
    }
  }, {
    key: 'hoverNextStep',
    value: function hoverNextStep(step) {
      var options = this.props.options;


      if (!options.some(this.isSelectableOption)) {
        return;
      }

      var newHovered = this.state.hovered;
      do {
        newHovered = Math.abs(modulu(Math.max(newHovered + step, -1), options.length));
      } while (!this.isSelectableOption(options[newHovered]));

      this.setState({ hovered: newHovered });
      this.options.scrollTop = (newHovered - 2) * 35;
    }
  }, {
    key: '_onKeyDown',
    value: function _onKeyDown(event) {
      if (!this.props.visible) {
        return false;
      }

      switch (event.key) {
        case 'ArrowDown':
          {
            this.hoverNextStep(1);
            break;
          }

        case 'ArrowUp':
          {
            this.hoverNextStep(-1);
            break;
          }

        case 'Enter':
          {
            if (!this._onSelect(this.state.hovered)) {
              return false;
            }
            break;
          }

        case 'Tab':
          {
            if (this.props.closeOnSelect) {
              return this._onSelect(this.state.hovered);
            } else {
              event.preventDefault();
              if (!this._onSelect(this.state.hovered)) {
                return false;
              }
            }
            break;
          }

        case 'Escape':
          {
            this._onClose();
            break;
          }

        default:
          {
            return false;
          }
      }

      event.preventDefault();
      event.stopPropagation();
      return true;
    }
  }, {
    key: '_onClose',
    value: function _onClose() {
      this.setState({
        hovered: NOT_HOVERED_INDEX
      });

      if (this.props.onClose) {
        this.props.onClose();
      }
    }
  }, {
    key: 'renderNode',
    value: function renderNode(node) {
      return node ? React.createElement(
        'div',
        { className: styles.node },
        node
      ) : null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames,
          _this2 = this;

      var _props3 = this.props,
          options = _props3.options,
          visible = _props3.visible,
          dropDirectionUp = _props3.dropDirectionUp,
          tabIndex = _props3.tabIndex,
          fixedHeader = _props3.fixedHeader,
          fixedFooter = _props3.fixedFooter,
          withArrow = _props3.withArrow;


      var contentContainerClassName = classNames((_classNames = {}, _defineProperty(_classNames, styles.contentContainer, true), _defineProperty(_classNames, styles.shown, visible), _defineProperty(_classNames, styles.up, dropDirectionUp), _defineProperty(_classNames, styles.down, !dropDirectionUp), _defineProperty(_classNames, styles.withArrow, withArrow), _classNames));

      return React.createElement(
        'div',
        { tabIndex: tabIndex, className: classNames(styles.wrapper, styles['theme-' + this.props.theme]), onKeyDown: this._onKeyDown },
        React.createElement(
          'div',
          { className: contentContainerClassName, style: { maxHeight: this.props.maxHeightPixels + 'px' } },
          this.renderNode(fixedHeader),
          React.createElement(
            'div',
            { className: styles.options, style: { maxHeight: this.props.maxHeightPixels - 35 + 'px' }, ref: function ref(options) {
                return _this2.options = options;
              }, 'data-hook': 'dropdown-layout-options' },
            options.map(function (option, idx) {
              return option.value === '-' ? _this2.renderDivider(idx) : _this2.renderItem({
                option: option,
                idx: idx,
                selected: option.id === _this2.state.selectedId,
                hovered: idx === _this2.state.hovered,
                disabled: option.disabled || option.title,
                title: option.title,
                overrideStyle: option.overrideStyle
              });
            })
          ),
          this.renderNode(fixedFooter)
        ),
        this.renderTopArrow()
      );
    }
  }, {
    key: 'renderDivider',
    value: function renderDivider(idx) {
      return React.createElement('div', { key: idx, className: styles.divider });
    }
  }, {
    key: 'renderItem',
    value: function renderItem(_ref) {
      var _classNames2,
          _this3 = this;

      var option = _ref.option,
          idx = _ref.idx,
          selected = _ref.selected,
          hovered = _ref.hovered,
          disabled = _ref.disabled,
          title = _ref.title,
          overrideStyle = _ref.overrideStyle;

      var optionClassName = classNames((_classNames2 = {}, _defineProperty(_classNames2, styles.option, !overrideStyle), _defineProperty(_classNames2, styles.selected, selected && !overrideStyle), _defineProperty(_classNames2, 'wixstylereactSelected', selected && overrideStyle), _defineProperty(_classNames2, styles.hovered, hovered && !overrideStyle), _defineProperty(_classNames2, 'wixstylereactHovered', hovered && overrideStyle), _defineProperty(_classNames2, styles.disabled, disabled), _defineProperty(_classNames2, styles.title, title), _classNames2));
      return React.createElement(
        'div',
        {
          className: optionClassName,
          onClick: !disabled ? function () {
            return _this3._onSelect(idx);
          } : null,
          key: idx,
          onMouseEnter: function onMouseEnter() {
            return _this3._onMouseEnter(idx);
          },
          onMouseLeave: this._onMouseLeave
        },
        option.value
      );
    }
  }, {
    key: 'renderTopArrow',
    value: function renderTopArrow() {
      var _classNames3;

      var _props4 = this.props,
          withArrow = _props4.withArrow,
          visible = _props4.visible,
          dropDirectionUp = _props4.dropDirectionUp;

      var arrowClassName = classNames((_classNames3 = {}, _defineProperty(_classNames3, styles.arrow, true), _defineProperty(_classNames3, styles.up, dropDirectionUp), _defineProperty(_classNames3, styles.down, !dropDirectionUp), _classNames3));
      return withArrow && visible ? React.createElement('div', { className: arrowClassName }) : null;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this4 = this;

      if (this.props.visible !== nextProps.visible) {
        if (nextProps.visible) {
          this.setState({ hovered: this.state.selectedId || NOT_HOVERED_INDEX });
        } else {
          this.setState({ hovered: NOT_HOVERED_INDEX });
        }
      }

      if (this.props.selectedId !== nextProps.selectedId) {
        this.setState({ selectedId: nextProps.selectedId });
      }

      if (!isEqual(this.props.options, nextProps.options)) {
        if (nextProps.options.some(function (option) {
          return !_this4.isLegalOption(option);
        })) {
          throw new Error('InputWithOptions: Invalid option provided');
        }

        if (this.state.hovered !== NOT_HOVERED_INDEX) {
          this.setState({
            hovered: nextProps.options.findIndex(function (item) {
              return item.id === _this4.props.options[_this4.state.hovered].id;
            })
          });
        }
      }
    }
  }, {
    key: 'isSelectableOption',
    value: function isSelectableOption(option) {
      return option.value !== '-' && !option.disabled && !option.title;
    }
  }]);

  return DropdownLayout;
}(WixComponent);

DropdownLayout.propTypes = {
  dropDirectionUp: PropTypes.bool,
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  visible: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    value: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
    disabled: PropTypes.bool,
    overrideStyle: PropTypes.bool
  })),
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tabIndex: PropTypes.number,
  theme: PropTypes.string,
  onClickOutside: PropTypes.func,
  fixedHeader: PropTypes.node,
  fixedFooter: PropTypes.node,
  maxHeightPixels: PropTypes.number,
  withArrow: PropTypes.bool,
  closeOnSelect: PropTypes.bool
};

DropdownLayout.defaultProps = {
  options: [],
  tabIndex: 1,
  selectedId: NOT_HOVERED_INDEX,
  maxHeightPixels: 260,
  closeOnSelect: true
};

DropdownLayout.NONE_SELECTED_ID = NOT_HOVERED_INDEX;

export default DropdownLayout;
//# sourceMappingURL=DropdownLayout.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/DropdownLayout/DropdownLayout.js